export default __webpack_public_path__ + "static/qt-sweetcombe-marque-5-star-orange-rgb-e05cf1a6f50e6d8a21f94a264e30926c.png";